module.exports = __webpack_public_path__ + "img/transverse.681290e7.svg";